<form [formGroup]="form" class="flex flex-col justify-center items-center space-y-4">
  <!-- Toggle para habilitar débito automático -->
  <div class="w-full mb-4">
    <label class="text-label">
      ¿Desea habilitar el débito automático?
    </label>
    
    <div class="flex flex-col space-y-2">
      <div class="flex items-center mt-2">
        <input
          formControlName="automaticDebit"
          class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          type="radio"
          id="automaticDebitYes"
          name="automaticDebit" 
          [value]="true"
        />
        <label for="automaticDebitYes" class="ml-2 block text-sm text-gray-900">Sí</label>
      </div>
      
      <div class="flex items-center">
        <input
          formControlName="automaticDebit"
          class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          type="radio"
          id="automaticDebitNo"
          name="automaticDebit"
          [value]="false"
        />
        <label for="automaticDebitNo" class="ml-2 block text-sm text-gray-900">No</label>
      </div>
    </div>
    @if(form.get('automaticDebit')?.invalid && (isTimeout || form.get('automaticDebit')?.touched)){
        <div 
            class="text-red-500 text-sm mt-1">
            Por favor selecciona una opción.
        </div>
}
  </div>

  <!-- Sección de detalles de débito (solo se muestra si seleccionó Sí) -->
  @if (showDebitDetails) {
    <!-- Selector para Tipo de Débito -->
    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    <!-- Campos para Débito Externo -->
    @if (form.get('debitType')?.value === 'EXTERNO') {
      <!-- Selector para Banco -->
      <app-selected class="w-full"
          [config]="dataSelected().at(1)"
          (selectValue)="handleValue($event)"
      ></app-selected>

      <!-- Input para Número de Cuenta -->
      @for (config of dataInputs(); track $index) {
        @if (config.formName === 'accountNumber') {
          <app-input
              class="w-full"
              [config]="config"
              (submitValue)="handleValue($event)"
          ></app-input>
        }
      }

      <!-- Selector para Tipo de Cuenta -->
      <app-selected class="w-full"
          [config]="dataSelected().at(2)"
          (selectValue)="handleValue($event)"
      ></app-selected>

      <!-- Input para Día Débito -->
      @for (config of dataInputs(); track $index) {
        @if (config.formName === 'debitDay') {
          <app-input
              class="w-full"
              [config]="config"
              (submitValue)="handleValue($event)"
          ></app-input>
        }
      }
    }
  }
</form>